import React, { useCallback } from "react";
import { Box, Chip, MenuItem, Select, SelectChangeEvent, Stack, Theme, Typography, useTheme } from "@mui/material";
import { PropertyGroup } from "../PropertyGroup";
import { useTreeDataContext, useTreeModifyContext } from "../TreeDataContext";
import { usePathContext } from "../PathInfo";

function getStyles(name: string, gamePieceNames: string[], theme: Theme) {
  const found = gamePieceNames.indexOf(name) !== -1;
  return {
    fontWeight: !found ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
    backgroundColor: found ? theme.palette.grey["400"] : theme.palette.background.paper,
  };
}

export function AcceptsEditor(props: { accepts: string[] }) {
  const { path } = usePathContext();
  const { saveChangesAtPath } = useTreeModifyContext();
  const theme = useTheme();
  const { getAllComponentNames } = useTreeDataContext();

  const selectRenderValue = useCallback((selected: any[]) => {
    if (selected.length === 0) {
      return <Typography>Empty</Typography>;
    }

    return (
      <Box className="horizontal-flex flex-wrap" maxWidth={"25rem"}>
        {selected.map((value) => (
          <Chip size={"small"} key={value} label={value} />
        ))}
      </Box>
    );
  }, []);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    saveChangesAtPath(event.target.value, path.concat(["accepts"]));
  };

  return (
    <PropertyGroup>
      <Typography id="accepts-label">Accepts:</Typography>
      <Select
        labelId="accepts-label"
        id="accepts-select-id"
        onChange={handleChange}
        value={props.accepts}
        displayEmpty
        multiple
        size={"small"}
        renderValue={selectRenderValue}
      >
        {getAllComponentNames().map((name) => (
          <MenuItem key={name} value={name} style={getStyles(name, props.accepts, theme)}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </PropertyGroup>
  );
}
